import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isTransparent = false;

  const navLinks = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Program', path: '/program' },
    { name: 'Konuşmacılar', path: '/konusmacılar' },
    { name: 'Kurslar', path: '/kurslar' },
    { name: 'Önemli Tarihler', path: '/onemli-tarihler' },
    { name: 'Genel Bilgiler', path: '/genel-bilgiler' },
    { name: 'Kayıt', path: '/kayit' },
    { name: 'İletişim', path: '/iletisim' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isTransparent
          ? 'bg-transparent'
          : 'bg-white shadow-xl'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-4 cursor-pointer group">
            <img 
              src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/432c5e6ce7481208eebd95eb1961bc97.png" 
              alt="GDH İstanbul 2025 Kongresi" 
              className="h-14 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
            />
            <img 
              src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/dc486e3cde18321da2d58739938a9509.png" 
              alt="GDHDER Logo" 
              className="h-20 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap relative group ${
                  location.pathname === link.path
                    ? 'text-accent'
                    : isTransparent
                      ? 'text-white hover:text-accent'
                      : 'text-primary hover:text-accent'
                }`}
              >
                {link.name}
                <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-accent transform origin-left transition-transform duration-300 ${
                  location.pathname === link.path ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                }`}></span>
              </Link>
            ))}
            <a
              href="https://kayit.gdhkongreleri.com.tr/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 bg-gradient-to-r from-accent to-accent-dark hover:from-accent-dark hover:to-accent text-white font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap shadow-md hover:shadow-xl transform hover:-translate-y-0.5"
            >
              Kayıt Ol
            </a>
          </div>

          {/* Mobile Right Section */}
          <div className="lg:hidden flex items-center space-x-3">
            <a
              href="https://kayit.gdhkongreleri.com.tr/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-4 py-2 bg-gradient-to-r from-accent to-accent-dark text-white font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap text-sm shadow-md"
            >
              Kayıt Ol
            </a>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`p-2 rounded-lg transition-all duration-300 cursor-pointer ${
                isTransparent
                  ? 'text-white hover:bg-white/20'
                  : 'text-primary hover:bg-gray-light hover:text-accent'
              }`}
            >
              <i
                className={`text-2xl transition-transform duration-300 ${
                  isMobileMenuOpen ? 'ri-close-line rotate-90' : 'ri-menu-line'
                }`}
              ></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 bg-white rounded-b-2xl shadow-xl animate-slide-down">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block px-4 py-3 font-semibold transition-all duration-300 cursor-pointer ${
                  location.pathname === link.path
                    ? 'text-accent bg-accent/10 border-l-4 border-accent'
                    : 'text-primary hover:bg-gray-light hover:text-accent hover:border-l-4 hover:border-accent'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="px-4 pt-3">
              <a
                href="https://kayit.gdhkongreleri.com.tr/"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full px-6 py-3 bg-gradient-to-r from-accent to-accent-dark text-white font-semibold rounded-lg transition-all duration-300 text-center cursor-pointer whitespace-nowrap shadow-md"
              >
                Kayıt Ol
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;